import React from 'react';
import { SumarryTableList } from '../../../components/table/SumarryTableList';
import { SummaryTableList } from '../../../components/table/SumarryTableColumnInfo';
import * as Const from '../../../utils/Const';

interface SelfStudyDetailSummaryDetailTableProps {
  data?: SummaryTableList[];
  summaryItemId: number;
}
//TODO interface SelfStudyDetailSummaryDetailTablePropsをまとめる
export const SelfStudyDetailSummaryDetailTable: React.FC<
  SelfStudyDetailSummaryDetailTableProps
> = ({ data, summaryItemId }) => {
  if (!data || data.length === 0) return <></>;

  return (
    <div className="mx-4 relative">
      <div className="sticky top-0 z-20 bg-white font-bold">
        {Const.LabelSelfStudyDetailSummaryDetailTableTitle}
      </div>
      <SumarryTableList summaryTableListData={data} summaryItemId={summaryItemId} />
    </div>
  );
};
